import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';

//Servicios
import { LogService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJCPLogs from './DJCPLogs';

function DJCPLogsContainer({}) {
    const { token, masters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJCPLogsPage, [state.DJCPLogsPage]);

    const [loader, setLoader] = useState(false);
    const [tablePages, setTablePages] = useState();

    const Params = useParams();

    useEffect(() => {
        const getDJCPLogsCuantity = async () => {
            try {
                setLoader(true);

                const DJCPLogsCuantity = await LogService.totalRecords({
                    token,
                    objeto: 4,
                    objeto_id: parseInt(Params.id),
                });

                if (DJCPLogsCuantity) setTablePages(DJCPLogsCuantity.data);

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getDJCPLogs = async () => {
            try {
                setLoader(true);

                const DJCPLogs = await LogService.byObject({
                    token,
                    objeto: 4,
                    objeto_id: parseInt(Params.id),
                    pagina: tablePage,
                    cantidad: tableData.pagination,
                });

                if (DJCPLogs) {
                    setTableData(buildTableData(DJCPLogs.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJCPLogsCuantity();
        getDJCPLogs();
    }, [tablePages, tablePage]);

    const buildTableData = (data = []) => {
        return {
            headers: ['Fecha', 'Hora', 'Responsable', 'Nivel', 'Acción'],
            tablePages,
            pagination: 10,
            tableType: 'DJCPLogsPage',
            data:
                data.length > 0
                    ? data?.map((log) => {
                          return {
                              fecha: dayjs(log.fecha).format('DD-MM-YYYY'),
                              hora: dayjs(log.fecha).format('HH:mm:ss'),
                              responsable: `${log.apellido}, ${log.nombre}`,
                              nivel: masters.UserTypes?.find(
                                  (m) => m.id === log.tipo
                              )?.nombre,
                              accion: masters.AccionTypes?.find(
                                  (at) => at.id === log.accion
                              ).nombre.replace(/_/g, ' '),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <DJCPLogs tableData={tableData} />;
}

export default DJCPLogsContainer;
